// extracted by mini-css-extract-plugin
export var card = "_47-0";
export var content = "_47-1";
export var contentLoading = "_47-2";